import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Headphones, Send, Loader2, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Public support chat — visitors (before login) can message the team; relayed to ZenZap.
// Open it from anywhere with: window.dispatchEvent(new Event("open-support"))
export function SupportChat() {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  useEffect(() => {
    const h = () => setOpen(true);
    window.addEventListener("open-support", h);
    return () => window.removeEventListener("open-support", h);
  }, []);

  const submit = async () => {
    if (!name.trim()) { toast.error("Non ou obligatwa"); return; }
    if (!phone.trim()) { toast.error("Tanpri mete yon nimewo telefòn pou nou ka rele w"); return; }
    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) { toast.error("Tanpri mete yon imèl valab"); return; }
    if (!message.trim()) { toast.error("Mesaj la obligatwa"); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/support/contact`, { name: name.trim(), email: email.trim(), phone: phone.trim(), message: message.trim() });
      setSent(true);
      setName(""); setEmail(""); setPhone(""); setMessage("");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erè. Tanpri eseye ankò.");
    } finally { setBusy(false); }
  };

  return (
    <>
      <button data-testid="support-fab" onClick={() => setOpen(true)}
        className="fixed bottom-5 right-5 z-40 h-14 w-14 rounded-full bg-[#00F593] text-black shadow-lg shadow-[#00F593]/30 flex items-center justify-center hover:scale-105 transition-transform"
        aria-label="Kontakte sipò">
        <Headphones className="h-6 w-6" />
      </button>

      <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) setSent(false); }}>
        <DialogContent data-testid="support-dialog"
          className="bg-[#0F0F0F] text-white border-0 p-0 gap-0 max-w-full w-screen h-[100dvh] left-0 top-0 translate-x-0 translate-y-0 rounded-none sm:rounded-none flex flex-col overflow-hidden">
          <DialogHeader className="px-5 py-4 border-b border-[#222] shrink-0">
            <DialogTitle className="flex items-center gap-2 font-heading pr-8">
              <Headphones className="h-5 w-5 text-[#00F593]" /> Chat ak Ekip Sipò a
            </DialogTitle>
          </DialogHeader>
          {sent ? (
            <div className="flex-1 flex flex-col items-center justify-center text-center space-y-3 px-6" data-testid="support-sent">
              <div className="mx-auto h-16 w-16 rounded-full bg-[#00F593]/15 flex items-center justify-center">
                <Send className="h-7 w-7 text-[#00F593]" />
              </div>
              <p className="font-heading font-semibold text-lg">Mèsi! Mesaj ou voye.</p>
              <p className="text-sm text-[#888] max-w-sm">Ekip TrzeFx la pral kontakte ou byento.</p>
              <Button onClick={() => setOpen(false)} className="mt-2 rounded-sm bg-white text-black hover:bg-[#e5e5e5]">Fèmen</Button>
            </div>
          ) : (
            <div className="flex-1 overflow-y-auto px-5 py-5 max-w-lg w-full mx-auto space-y-3">
              <p className="text-sm text-[#888]">Kite yon mesaj — yon ajan reyèl nan ekip la ap reponn ou. <span className="text-[#00F593]">Tout chan yo obligatwa.</span></p>
              <Input data-testid="support-name" value={name} onChange={(e) => setName(e.target.value)}
                placeholder="Non ou *" className="bg-[#0A0A0A] border-[#222] rounded-sm h-12" />
              <Input data-testid="support-phone" value={phone} onChange={(e) => setPhone(e.target.value)}
                type="tel" placeholder="Nimewo telefòn (pou nou rele w) *" className="bg-[#0A0A0A] border-[#222] rounded-sm h-12" />
              <Input data-testid="support-email" value={email} onChange={(e) => setEmail(e.target.value)}
                type="email" placeholder="Imèl ou *" className="bg-[#0A0A0A] border-[#222] rounded-sm h-12" />
              <Textarea data-testid="support-message" value={message} onChange={(e) => setMessage(e.target.value)}
                placeholder="Kijan nou ka ede ou? *" rows={6} className="bg-[#0A0A0A] border-[#222] rounded-sm" />
              <Button data-testid="support-submit" onClick={submit} disabled={busy}
                className="w-full h-12 rounded-sm bg-[#00F593] text-black hover:bg-[#00d97f] font-semibold">
                {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Send className="h-4 w-4 mr-1.5" />Voye Mesaj</>}
              </Button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
